import React, { useState } from "react";
import "../../css_files/UploadDownload/UploadDownload.css";
import axios from "axios";

function UploadDownload() {
  const [uploadDownload, setUploadDownload] = useState("Download");
  const [selectedSubHead, setSelectedSubHead] = useState("");
  const [options, setOptions] = useState([]);
  const [selectedHead, setSelectedHead] = useState("");
  const [file, setFile] = useState(null);

  function handleSubmit(e) {
    e.preventDefault();
    if (uploadDownload === "Upload") {
    } else {
      axios
        .post(
          `${process.env.REACT_APP_API_URL}/api/UploadDownload/Download`,
          {
            Head: selectedHead,
            SubHead: selectedSubHead,
          },
          {
            responseType: "blob",
          }
        )
        .then((res) => {
          const url = URL.createObjectURL(res.data);
          const element = document.createElement("a");
          element.href = url;
          element.download = "Sample.xlsx";
          element.click();
        })
        .catch(console.log);
    }
  }
  return (
    <div className="upload-download-screen">
      <h1>Upload and Download</h1>
      <blockquote>
        <button
          onClick={() => {
            setUploadDownload("Upload");
          }}
        >
          <i className="fa-solid fa-upload"></i>
          Upload
        </button>
        <button
          onClick={() => {
            setUploadDownload("Download");
          }}
        >
          <i className="fa-solid fa-download"></i>
          Download
        </button>
      </blockquote>
      <form onSubmit={handleSubmit}>
        <blockquote>
          <label>Head</label>
          <select
            required
            onChange={(e) => {
              setSelectedHead(e.target.value);
              switch (e.target.value) {
                case "Master":
                  setOptions([
                    "Category",
                    "SubCategory",
                    "HSN",
                    "Unit",
                    "Packing",
                    "Currency",
                    "GST",
                    "Parts",
                    "Boiler",
                    "Boiler Series",
                    "Boiler Series Mapping",
                    "Courier",
                    "Customer",
                    "Customer Pricing",
                    "Technician",
                  ]);
                  break;
                case "Operation":
                  setOptions([
                    "Enquiry",
                    "Tickets",
                    "Quotations",
                    "Orders",
                    "Invoice",
                  ]);
                  break;
                default:
                  setOptions([]);
                  break;
              }
            }}
          >
            <option value="">Select Head</option>
            <option value="Master">Master</option>
            <option value="Operation">Operation</option>
          </select>
        </blockquote>
        <blockquote>
          <label>Sub Head</label>
          <select
            required
            onChange={(e) => {
              setSelectedSubHead(e.target.value);
            }}
          >
            <option value="">Select SubHead</option>
            {options.map((x) => (
              <option value={x}>{x}</option>
            ))}
          </select>
        </blockquote>
        {uploadDownload === "Upload" && (
          <blockquote>
            <label>File</label>
            <input
              type="file"
              required
              accept="application/xlsx"
              onChange={(e) => {
                setFile(e.target.files[0]);
              }}
            />
          </blockquote>
        )}
        <button type="submit">Submit</button>
      </form>
    </div>
  );
}

export default UploadDownload;
